import React, { useCallback } from "react";
import { useField, useFormikContext } from "formik";
import { RichTextEditor } from "./RichTextEditor";
import type { RichTextEditorProps } from "./RichTextEditor";

interface FormikRichTextEditorProps extends Omit<RichTextEditorProps, "value" | "onChange"> {
	name: string;
}

export const FormikRichTextEditor: React.FC<FormikRichTextEditorProps> = ({
	name,
	...props
}) => {
	const [field, meta] = useField<string>(name);
	const { setFieldValue, setFieldTouched } = useFormikContext();

	const hasError = !!(meta.error && meta.touched);

	const handleChange = useCallback(
		(html: string) => {
			setFieldValue(name, html);
			setFieldTouched(name, true);
		},
		[name, setFieldValue, setFieldTouched]
	);

	return (
		<RichTextEditor
			{...props}
			value={field.value || ""}
			onChange={handleChange}
			hasError={hasError}
			errorText={meta.touched ? meta.error : undefined}
		/>
	);
};
